import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT, APP_NAME } from '../../../constants';
import { FUNNEL_ADDRESS_STEP } from '../../../constants/funnel';

import { getCashbackAmount } from '../../../utils/ebonUtils';
import { getMerchantCardUrl } from '../../../services/partner/utils';
import { getPartnerIdFromQuery, getPartnerNameFromQuery } from '../../../utils';
import { doCartTotalTtc, mapPartner, mapUserCart } from '../../../utils/cartUtils';

import Stepper from './Stepper';
import { Logo } from '../../icons/Logo';
import SvgComponent from '../../SvgComponent';
import HeadComponent from '../../HeadComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

import EbonErrorModal from '../../funnel/EbonErrorModal';
import ScriptContainer from '../../funnel/ScriptContainer';
import FunnelLeftContainer from '../../funnel/FunnelLeftContainer';
import FunnelRightContainer from '../../funnel/FunnelRightContainer';

import { Template } from '../../template/TemplateStyle';
import { HeaderNav } from '../../header/HeaderNavComponentStyle';
import { EbonValidationPageContainer } from './ValidationEbonPageStyle';
import { Header, HeaderGlobalStyle } from '../../header/HeaderComponentStyle';

const ValidationEbonPage = ({
    i18n,
    ebon,
    userCart,
    order,
    history,
    partner,
    queryPartnerId,
    queryPartnerName
}) => {
    const [userInfo, setUserInfo] = useState({});
    const [modalData, setModalData] = useState(null);
    const [paymentType, setPaymentType] = useState();
    const [stateOfTransaction, setStateOfTransaction] = useState(FUNNEL_ADDRESS_STEP);
    const [kycNeeded, setKycNeeded] = useState(false);

    const partnerId = partner ? partner.id : queryPartnerId;
    const partnerName = partner ? partner.name : queryPartnerName;
    const merchantCardPath = getMerchantCardUrl({ id: partnerId, name: partnerName }, false, true);

    const amountCashback = getCashbackAmount(ebon.ebons);
    const cartTotalValue = doCartTotalTtc(userCart, amountCashback);

    useEffect(() => {
        if (userCart.length === 0) {
            new Promise((resolve, reject) => {
                history.push(merchantCardPath);
                resolve();
            });
        }
    }, []);

    return (
        <Template className="flex-container-v">
            <ScriptContainer order={order} />
            <HeaderNav className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <Header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <HeaderGlobalStyle />
                        <LocalizedNavLink to={PATH.HOME_PATH} title={APP_NAME} className="logo">
                            <Logo />
                        </LocalizedNavLink>
                        <Stepper
                            steps={i18n.STEPS}
                            current={order.orderState === 'created' ? 2 : 1}
                        />
                    </Header>
                </div>
            </HeaderNav>
            <EbonValidationPageContainer className="conteneur conteneur-mobile">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />

                <Stepper
                    steps={i18n.STEPS}
                    current={order.orderState === 'created' ? 2 : 1}
                    cssClass="mobileDisplay"
                />

                <div className="goBack">
                    <LocalizedNavLink
                        to={merchantCardPath}
                        className="fakelink"
                        title={i18n.GO_BACK}>
                        <SvgComponent src={`${STATIC_ROOT}/chevron.svg`} width="12" height="12" />
                        {i18n.GO_BACK}
                    </LocalizedNavLink>
                </div>

                {!modalData ? (
                    <div className="mainContainer">
                        <FunnelLeftContainer
                            partnerId={partnerId}
                            partnerName={partnerName}
                            userInfo={userInfo}
                            setUserInfo={setUserInfo}
                            paymentType={paymentType}
                            setPaymentType={setPaymentType}
                            cartTotalValue={cartTotalValue}
                            stateOfTransaction={stateOfTransaction}
                            setStateOfTransaction={setStateOfTransaction}
                            setModalData={setModalData}
                            merchantCardPath={merchantCardPath}
                            kycNeeded={kycNeeded}
                            setKycNeeded={setKycNeeded}
                        />

                        <FunnelRightContainer
                            partnerId={partnerId}
                            userInfo={userInfo}
                            userCart={userCart}
                            stateOfTransaction={stateOfTransaction}
                            setStateOfTransaction={setStateOfTransaction}
                            amountCashback={amountCashback}
                            cartTotalValue={cartTotalValue}
                            paymentType={paymentType}
                            order={order}
                            kycNeeded={kycNeeded}
                        />
                    </div>
                ) : (
                    <EbonErrorModal
                        modalData={modalData}
                        merchantCardPath={merchantCardPath}
                        partnerName={partnerName}
                    />
                )}
            </EbonValidationPageContainer>
        </Template>
    );
};

const mapStateToProps = (state, ownProps) => {
    const queryPartnerId = getPartnerIdFromQuery(ownProps.match.params.query);
    const queryPartnerName = getPartnerNameFromQuery(ownProps.match.params.query);

    return {
        i18n: state.i18n.page.EBON,
        ebon: state.ebon,
        order: state.ebon.createdOrder,
        userCart: mapUserCart(state.ebon.cart, state.ebon.ebonPartners),
        partner: mapPartner(state.ebon.cart, state.ebon.ebonPartners),
        queryPartnerId: queryPartnerId,
        queryPartnerName: queryPartnerName
    };
};

export default withRouter(connect(mapStateToProps)(ValidationEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/ValidationEbonPage.js